
import React from 'react';
import MainLayout from '../Layouts/Mainlayout';
import TriggerList from './TriggerList';

export default function Users(): JSX.Element {
  return (
    <div className="flex flex-row justify-start">
      <MainLayout>
        <TriggerList />
      </MainLayout>
    </div>
  );
}
